import React from 'react';

export default function CustomItem(data) {
    return (
        <div>
            <div className="disclaimer-text">
                <p><b>{data.main}</b></p>
                <p>{data.appendix}</p>

            </div>
            <div className="disclaimer-text-part2">
                <p>{data.appendix2}</p>
            </div>
            <div className="disclaimer-text">
                <p>{data.appendix1}</p>
                <p>{data.appendix3}</p>
                <p>{data.appendix4}</p>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./App/containers/layout/customItem.jsx